<template>
  <div id="menu" class="menu">
    <!-- 詳細検索 -->
    <transition name="popup">
      <SPQASearchDetail
        v-if="state.visibleSearchDetail"
        :startLoading="state.visibleSearchDetail"
        :parentName="'SPMenu'"
        :parentNameOfMenu="menu.parentName"
        @searchDetail="search.searchDetail"
        @closeSearchDetail="state.visibleSearchDetail = false"
        @closeMenu="closeMenu"
      />
    </transition>

    <div class="menu-wrapper">
      <header class="menu-header">
        <a @click.prevent="goToProfile" class="menu-header-profile">
          <span v-if="profile.user_icon > 0" class="image" :style="{backgroundImage : 'url(' + profile.user_icon_image + ')'}"></span>
          <span v-else class="image no-link">{{profile.name.slice(0, 1)}}</span>
          <span class="name">{{profile.name}}</span>
          <FontawesomeIcon :icon="['fas','angle-down']" class="icn"/>
        </a>
        <a @click.prevent.stop="menu.routerTo('SPAlertList')" role="button" class="menu-header-alert">
          <FontawesomeIcon :icon="['fas','bell']" class="icn" />
          <span v-if="alert.count > 0" class="menu-header-alert-num">{{alert.count_disp}}</span>
        </a>
      </header>
      <div class="menu-container">
        <form @submit.prevent="search.clickSearch" :class="search.gaSearchClass">
          <ul class="menu-list">
            <li class="menu-list-item">
              <span class="menu-hdg">検索</span>
              <div class="column">
                <div class="column-item col-12">
                  <div class="formparts select mb12"
                    v-click-outside="() => { state.isOpenSearchCategory = false }"
                    :class="{'is-visible-list': state.isOpenSearchCategory}"
                  >
                    <div @click="state.isOpenSearchCategory = !state.isOpenSearchCategory" 
                      class="select-label" role="select">{{ search.searchCategoryName }}<FontawesomeIcon :icon="state.isOpenSearchCategory ? 'angle-up' : 'angle-down'" class="icn" /></div>
                    <div class="select-option">
                      <ul class="select-option-list ta-center">
                        <li class="ta-center" role="option"><label><input type="radio" v-on:change="search.changeCategory" v-model="search.searchCategory" value="qa">Q&amp;A・事例</label></li>
                        <li class="ta-center" role="option"><label><input type="radio" v-on:change="search.changeCategory" v-model="search.searchCategory" value="knowledge">最新ナレッジ</label></li>
                        <li class="ta-center" role="option"><label><input type="radio" v-on:change="search.changeCategory" v-model="search.searchCategory" value="book">書籍目次</label></li>
                        <li class="ta-center" role="option"><label><input type="radio" v-on:change="search.changeCategory" v-model="search.searchCategory" value="note">ノート</label></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="column-item col-12">
                  <div class="formparts search mb8">
                    <span @click="search.clickSearch" role="button"><FontawesomeIcon :class="search.gaSearchClass" :icon="['far','search']" size="2x" class="icn" /></span>
                    <input v-model="search.keyword_input" type="text" maxlength="50" placeholder="キーワードを入力（最大50文字）">
                  </div>
                </div>
                <div v-if="search.searchCategory !== 'note' && search.searchCategory !== 'download'"
                  class="column-item col-6 is-fuzzy-box-outer">
                  <div class="formparts checkbox mb8 is-fuzzy-box-inner">
                    <input type="checkbox" id="menu_is_fuzzy"
                      v-model.number="search.is_fuzzy_input"
                      :true-value="0"
                      :false-value="1"
                    >
                    <label
                      for="menu_is_fuzzy">表記ゆれ・同意語を含む<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                </div>
                <div v-if="search.searchCategory === 'qa'" class="column-item col-6">
                  <div class="button mb8">
                    <span @click="state.visibleSearchDetail = true" class="btn">詳細検索</span>
                  </div>
                </div>
                <div class="column-item col-12">
                  <div class="button-row-wrap row-2 mb8">
                    <div class="button" 
                      v-if="search.searchCategory === 'qa' || search.searchCategory === 'knowledge'"
                      >
                      <a @click.prevent.stop="menu.routerTo('SPSearchConditionList')" class="btn">保存検索条件</a>
                    </div>
                    <div class="button"
                      v-if="search.searchCategory === 'qa' || search.searchCategory === 'knowledge' || search.searchCategory === 'note'"
                    >
                      <a @click.prevent.stop="menu.routerTo('SPHistoryOfSearch')" class="btn">検索履歴</a>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="menu-list-item">
              <span class="menu-hdg">メニュー</span>
              <div class="column gutter">
                <div class="column-item space-gutter col-6">
                  <div class="button">
                    <a @click.prevent.stop="menu.routerTo('SPDashboard')" class="btn">ダッシュボード</a>
                  </div>
                </div>
                <div class="column-item space-gutter col-6">
                  <div class="button">
                    <a @click.prevent.stop="menu.routerTo('SPBookList')" class="btn">書籍</a>
                  </div>
                </div>
                <div class="column-item space-gutter col-6">
                  <div class="button">
                    <a @click.prevent.stop="menu.routerTo('SPKnowledgeList')" class="btn">最新ナレッジ</a>
                  </div>
                </div>
                <div class="column-item space-gutter col-6">
                  <div class="button">
                    <a @click.prevent.stop="menu.routerTo('SPNoteList')" class="btn">ノート</a>
                  </div>
                </div>
                <div class="column-item space-gutter col-6">
                  <div class="button">
                    <a @click.prevent.stop="menu.routerTo('SPViewLaterList')" class="btn">後で見る</a>
                  </div>
                </div>
                <div class="column-item space-gutter col-6">
                  <div class="button">
                    <a @click.prevent.stop="menu.routerTo('SPBookmarkList')" class="btn">ブックマーク</a>
                  </div>
                </div>
                <div class="column-item space-gutter col-6">
                  <div class="button">
                    <a @click.prevent.stop="menu.routerTo('SPHistoryOfView')" class="btn">閲覧履歴</a>
                  </div>
                </div>
                <div v-show="state.isDocumentLinkShown" class="column-item space-gutter col-6">
                  <div class="button">
                    <a href="/lc/app/document-top/" class="btn" target="_blank">
                      資料検索
                      <FontawesomeIcon :icon="['far','external-link']" class="icn ml8" />
                    </a>
                  </div>
                </div>
              </div>
            </li>
            <li class="menu-list-item">
              <span class="menu-hdg">管理メニュー</span>
              <p class="menu-text mb20">スマートフォンからはご利用頂けません。</p>
              <div class="button">
                <a @click.prevent.stop="menu.routerTo('SPInquiryInput')" class="btn">お問い合わせ</a>
              </div>
            </li>
            <li class="menu-list-item">
              <p class="menu-link-txt"><a @click.prevent.stop="menu.routerTo('SPGuideTop')" role="button">ご利用ガイド</a></p>
            </li>
            <li class="menu-list-item">
              <p class="menu-link-txt"><a href="https://www.sn-hoki.co.jp/guide/social_rules/" target="_blank">利用規約 <FontawesomeIcon icon="external-link-alt" class="icn" /></a></p>
              <p class="menu-link-txt"><a href="https://www.sn-hoki.co.jp/privacy/" target="_blank">プライバシーポリシー <FontawesomeIcon icon="external-link-alt" class="icn" /></a></p>
              <p class="menu-link-txt"><a href="https://www.sn-hoki.co.jp/guide/tradelaw/" target="_blank">特定商取引法に基づく表示 <FontawesomeIcon icon="external-link-alt" class="icn" /></a></p>
            </li>
            <li class="menu-list-item">
              <p class="menu-copy">Copyright (C) 2021<br>SHINNIPPON-HOKI PUBLISHING CO.,LTD.</p>
            </li>
          </ul>
        </form>

      </div>
    </div>

    <div class="menu-close"
      @click="closeMenu"
    >
      <FontawesomeIcon :icon="['fas','times']" size="lg" class="icn icn-opened"/>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onBeforeMount, onBeforeRouteUpdate } from '@vue/composition-api'
import router from '@/router'
import ClickOutside from 'vue-click-outside'

import SPQASearchDetail from '@/components/sp/popup/SPQASearchDetail'
import SPQASearchDetailBookList from '@/components/sp/popup/SPQASearchDetailBookList.vue'
import SPQASearchDetailPackageList from '@/components/sp/popup/SPQASearchDetailPackageList.vue'
import SPQASearchDetailCourtList from '@/components/sp/popup/SPQASearchDetailCourtList.vue'
import SPQASearchDetailPastYearBookList from '@/components/sp/popup/SPQASearchDetailPastYearBookList.vue'

import * as logicMenu from '@/logic/Menu'

export default defineComponent({
  components: {
    SPQASearchDetail,
    SPQASearchDetailBookList,
    SPQASearchDetailPackageList,
    SPQASearchDetailCourtList,
    SPQASearchDetailPastYearBookList
  },
  directives: {
    ClickOutside
  },
  props: {
    // 呼び出し元の名前
    parentName: {
      type: String,
      default: ''
    },
    // メニュー表示フラグ(SP用)
    parentVisibleMenu: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {

    const { state, alert, profile, menu, background, search, closeMenu } = logicMenu.getGroup(props, context)

    const goToProfile = () => {
      closeMenu()
      router.push({ name: 'SPProfile' }).catch(() => {})
    }

    return {
      state,
      alert,
      profile,
      menu,
      background,
      search,
      closeMenu,
      goToProfile
    }
  }
})
</script>

<style lang="scss" scoped>
// ノートの編集モード
.is-visible-editmode {
  .menu-close {
    bottom: 78px;
  }
}
.menu {
  position: fixed;
  top: 0;
  bottom: 0;
  // transform-origin: right;
  z-index: $index-menu;
  overflow-y: auto;
  // background-size: cover;
  // background-position: center;
  color: #fff;
  width: 100%;

  // hidden
  &-container {
    margin-bottom: 40px;
  }
  &-close {
    width: 82px;
    height: 72px;
    background-color: $color-link;
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 2;
    border-top-left-radius: 8px;

    // transition
    transition: all .2s ease;
    visibility: hidden;
    opacity: 0;
    .icn {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%,-50%,0);
    }
  }
  &-header {
    padding: 20px;
    display: flex;
    align-items: center;
    &-profile {
      width: calc(100% - 58px);
      display: flex;
      align-items: center;
      color: #fff;
      .image {
        display: block;
        width: 40px;
        height: 40px;
        background-size: cover;
        background-position: center;
        border-radius: 50%;
        margin-right: 10px;
        &.no-link {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 2.0rem;
          color: $color-hdg;
          font-weight: bold;
          background-color: $color-no-image;
        }
      }
      .name {
        font-size: 1.8rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow-x: hidden;
        flex: 1 1 0;
      }
      .icn {
        margin-left: 1em;
      }
    }
    &-alert {
      display: block;
      width: 48px;
      height: 48px;
      border: 1px solid rgba(255,255,255,.2);
      border-radius: 4px;
      position: relative;
      color: #fff;
      margin-left: 10px;
      .icn {
        position: absolute;
        top: 50%;
        left: 50%;
        font-size: 2.0rem;
        transform: rotate(45deg)translate3d(-67%,0,0);
      }
      &-num {
        display: block;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background-color: #fff;
        color: $color-link;
        font-size: 1.4rem;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: -8px;
        top: -8px;
      }
    }
  }
  &-hdg {
    font-size: 1.6rem;
    font-weight: bold;
    margin-bottom: 16px;
    display: block;
  }
  &-txt {
    color: #fff;
    font-size: 1.4rem;
  }
  &-link-txt {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    a {
      color: #fff;
      font-size: 1.2rem;
    }
  }
  &-copy {
    font-size: 1.2rem;
    line-height: 1.5;
  }
  &-list {
    &-item {
      padding: 20px;
      border-top: 1px solid rgba(255,255,255,.2);
    }
  }

  .formparts {
    &.select {
      .select-label {
        border-color: #fff;
        color: #fff;
        padding-right: 32px;
        font-size: 1.4rem;
        .icn {
          color: #fff;
          right: 22px;
        }
      }
    }
    &.search {
      .icn {
        color: #fff;
      }
      input {
        color: #fff;
        border-color: #fff;
        height: 48px;
        &::placeholder {
          color: #fff;
        }
      }
    }
    &.checkbox {
      label {
        color: #fff;
        font-size: 1.4rem;
      }
    }
  }
  .button {
    .btn {
      background-color: transparent;
      border-color: #fff;
      color: #fff;
      font-size: 1.4rem;
    }
  }
  .is-fuzzy-box-outer {
    display: table;
    .is-fuzzy-box-inner {
      display: table-cell;
      height: 48px;
      vertical-align: middle;
    }
  }
}
</style>
